import Api from '@/api'
import Vue from 'vue'
import router from '../../router'

export default {
  namespaced: true,
  state: {
    trial: null,
    project: null,
    error: null
  },
  actions: {
    set(context,params){
      // no estoy muy seguro, pero sino se quedaban los "viejos" guardados cuando navegabas...
      if(!params.project) params.project = null
      if(!params.trial) params.trial = null
      if(!params.subject) params.subject = null
      context.dispatch('fetchAndSet',{params})
    },
    fetchAndSet(context,{params,skipReset}){
      Object.keys(params).forEach((p)=>{
        let getter
        switch(p){
          case 'project': getter = Api.getProject; break;
          case 'trial': getter = Api.getTrial; break;
          case 'subject': getter = Api.getSubject; break;
        }
        // no estoy muy seguro, pero sino se quedaban los "viejos" guardados cuando navegabas...
        if(params[p]===null) {
          context.dispatch('setValue', {key:p, value: null})
          return
        }
        let forceFetch = p==='project' && context.state._pending_project
        if(forceFetch && !skipReset){
          context.dispatch('setValue', {key:p, value: null})
        }
        context.state._pending_project = false
        if(!context.state[p] || context.state[p].id!=params[p] || forceFetch){
          console.log(`FETCH (forced: ${forceFetch}): {${p}: ${params[p]}}`)
          context.dispatch('setValue', {key:'error', value: null})
          getter.call(Api,params).then((response)=>{
            // temporary fix to check if baseline trials are present in the project without affecting DB (to be handled from BE in the future)
            if (p == 'project') {
              let projectIncludesBaselines = response.trials.some(trial => trial.name.includes('Baseline') || trial.name.includes('baseline'))
              response['baselinesAreIncluded'] = projectIncludesBaselines
            }
            //
            context.dispatch('setValue', {key:p, value: response})

          }).catch(err => {
            context.dispatch('setValue', {key:'error', value: err.response && err.response.data ? err.response.data.detail : err.message})
          })
        }
      })
    },
    setValue(context,{key,value}){
      if(key==='trial' && context.state.project) {
        context.state._pending_project = true
        if(router.history.current.name==="ProjectDetailsView"){
          context.dispatch('fetchAndSet',{
            params:{
              project: context.state.project.id,
            },
            skipReset: true
          })
        } 
      }
      context.commit('set',{key,value})
    }
  },
  mutations: {
    set (state, ob){
      // ALTANTO con estos Vue.set // OBject.assign, parece que ya no hacen falta...
      // Estropeaban el nuevo sistema de "setValueFromStore"
      // console.log(`STATE MUTATION: {${ob.key}: ${ob.value.id}}`)
      // if(!ob.value) {
      //   delete state[ob.key]
      // } else 
      if(!state[ob.key]) {
        // state[ob.key]=ob.value 
        Vue.set(state, ob.key, ob.value)
      } else {
        state[ob.key] = ob.value
        // Object.assign({}, state[ob.key], ob.value)
        // Vue.set(state, ob.key, ob.value)
      }
      // state = {...state}
    }
  }
}